import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../i18n';

/**
 * Page de transition : quand l'installateur clique sur une carte client,
 * on stocke l'orgId actif puis on redirige vers le vrai dashboard du client.
 */
export default function ClientDashboardView() {
  const { orgId } = useParams<{ orgId: string }>();
  const navigate = useNavigate();
  const { token } = useAuth();
  const { t } = useI18n();

  const API = import.meta.env.VITE_WATTELZCE_API_URL || '/api/wattelzce';

  useEffect(() => {
    if (!orgId) return;
    fetch(`${API}/api/my-clients/${orgId}/dashboard`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          sessionStorage.setItem('actingClientOrgId', String(data.client.orgId));
          sessionStorage.setItem('actingClientName', data.client.orgName);
          navigate('/wattel-em', { replace: true });
        } else {
          navigate('/my-clients', { replace: true });
        }
      })
      .catch(() => navigate('/my-clients', { replace: true }));
  }, [orgId, token, API, navigate]);

  return (
    <div className="flex items-center justify-center h-full p-12">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-teal-600 mx-auto mb-3" />
        <p className="text-sm text-gray-500">{t('team_clients_opening')}</p>
      </div>
    </div>
  );
}
